import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

export const useFormInputLabelWithSuffix = ({
  label,
  optional
}: {
  label: string
  optional?: boolean
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  let suffix = ''
  if (optional) suffix = ` (${t('shiftEvent.label.optional')})`

  return label + suffix
}
